import React, { useCallback, useMemo, useState } from 'react';

import { Bus, NotificationManager, prepareRequest, useApplicationState } from '@atlas/core';
import { Button, Label } from '@atlas/ui';

const VerifyBlock = () => {
  const applicationState = useApplicationState();
  const { account: { email, emailVerificationRequested, emailVerified } = {} } = applicationState;

  const [loading, setLoading] = useState(false);

  const verifyHandler = useCallback(async () => {
    setLoading(true);
    try {
      const request = prepareRequest({
        method: 'POST',
        url: 'client/clients/email/confirmation-request',
      });
      await request();
      Bus.emit(Bus.events.profile.accountUpdate, { emailVerificationRequested: true });
      NotificationManager.notify({
        message: 'verification_request_successful',
        status: 'success',
        type: 'notification',
      });
    } catch (error) {
      NotificationManager.notify({
        message: 'verification_request_unsuccessful',
        status: 'error',
        type: 'notification',
      });
    } finally {
      setLoading(false);
    }
  }, []);

  const renderButton = useMemo(() => {
    if (!email || emailVerified || emailVerificationRequested) {
      return null;
    }
    return (
      <div className="verify-email-container">
        <Button
          className="block"
          disabled={loading}
          label="verify_email"
          loading={loading}
          onClick={verifyHandler}
          size="big"
          type="primary"
        />
      </div>
    );
  }, [email, emailVerified, verifyHandler, emailVerificationRequested, loading]);

  return (
    <>
      {emailVerificationRequested && !emailVerified && (
        <div className="verify-email-container popup-title-content">
          <Label className="main-label" message="email_verification_request_title" />
          <Label className="sub-label" message="verification_request_successful" />
        </div>
      )}
      {emailVerified && (
        <div className="varified-badge absolute">
          <Label className="verified-badge-label" message="verified" />
        </div>
      )}
      {renderButton}
    </>
  );
};

export default VerifyBlock;
